// Only known OCR sentences are safe to display.
export const CARD_SCAN_MESSAGES = [
  "We couldn't read the card clearly. Please retake the photo in good light, or enter the details manually.",
  "We couldn't find a Medicare number or name on that image. Please retake the photo or enter the details manually.",
  "We couldn't read the Medicare number on that card - please type it in. The name below was read from the card, so check it too.",
  "We couldn't read the name on that card - please type it in. The Medicare number below was read from the card, so check it too.",
];
